import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { oneKlicks } from "../../../../../SDK/oneclick";
import { OneKlicksFileSDK } from "../../../../../SDK/OneKlicksFileSDK";
import { getuserdata } from "../../../../../services/apiService";
import { toast } from "react-toastify";
import FileDownload from "./FileDownload";

const Downloads = ({ downloads: initialDownloads, setDownloads }) => {
    const [localDownloads, setLocalDownloads] = useState([]);
    const [isUploading, setIsUploading] = useState(false);

    useEffect(() => {
        if (initialDownloads) {
            try {
                const parsedDownloads = typeof initialDownloads === 'string'
                    ? JSON.parse(initialDownloads)
                    : initialDownloads;
                setLocalDownloads(Array.isArray(parsedDownloads) ? parsedDownloads : []);
                setDownloads(Array.isArray(parsedDownloads) ? parsedDownloads : []);
            } catch (e) {
                console.error("Error parsing downloads:", e);
                setLocalDownloads([]);
                setDownloads([]);
            }
        }
    }, [initialDownloads, setDownloads]);

    const addDownload = () => {
        const newDownload = {
            id: Date.now(),
            title: '',
            description: '',
            file: null,
            file_id: null
        };
        setLocalDownloads([...localDownloads, newDownload]);
        setDownloads([...localDownloads, newDownload]);
    };

    const handleDownloadChange = (index, field, value) => {
        const updatedDownloads = [...localDownloads];
        updatedDownloads[index] = {
            ...updatedDownloads[index],
            [field]: value
        };
        setLocalDownloads(updatedDownloads);
        setDownloads(updatedDownloads);
    };

    const handleFileUpload = async (index, file) => {
        if (!file) return;




        setIsUploading(true);
        try {
            const root = "pharmacy/downloads";
            const status = "public";
            const uploadedFile = await OneKlicksFileSDK.uploadFile(root, status, file);

            if (uploadedFile.success) {
                const updatedDownloads = [...localDownloads];
                updatedDownloads[index] = {
                    ...updatedDownloads[index],
                    file: file.name,
                    file_id: uploadedFile.fileId
                };
                setLocalDownloads(updatedDownloads);
                setDownloads(updatedDownloads);
                toast.success("File uploaded successfully");
            } else {
                throw new Error(uploadedFile.error || "Failed to upload file");
            }
        } catch (err) {
            console.error("Error uploading file:", err);
            toast.error(err.message || "Failed to upload file");
        } finally {
            setIsUploading(false);
        }
    };

    const deleteDownload = async (id) => {
        const filteredDownloads = localDownloads.filter(download => download.id !== id);
        setLocalDownloads(filteredDownloads);
        setDownloads(filteredDownloads);

        try {
            const tableSchema = "";
            const tableName = "pharmacy_awards_downloads";
            const data = {
                downloads: JSON.stringify(filteredDownloads)
            };
            const condition = {
                user_id: await getuserdata("id")
            };
            const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);
            if (updateData.success) {
                toast.success("Download deleted successfully");
            }
        } catch (error) {
            console.error("Error deleting download:", error);
            toast.error("Failed to delete download");
        }
    };

    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-personalskillshold tab-pane active fade show" id="dc-skills">
                <div className="dc-userdownloads dc-tabsinfo">
                    <div className="dc-tabscontenttitle dc-addnew">
                        <h3>Add Your Downloads</h3>
                        <Button className="dc-btn dc-btnactive new" onClick={addDownload} style={{ float: 'right' }}>Add New</Button>
                    </div>
                    <ul className="dc-downloadsaccordion accordion dc-downloads">
                        {Array.isArray(localDownloads) && localDownloads.map((download, index) => (
                            <li key={download.id}>
                                <div className="dc-accordioninnertitle">
                                    <span id={`accordioninnertitle${index}`} data-toggle="collapse" data-target={`#innertitle${index}`}>
                                        {download.title || 'Download title'}
                                    </span>
                                    <em>{download.file || 'No file uploaded'}</em>
                                    <div className="dc-rightarea">
                                        <a className="dc-addinfo dc-skillsaddinfo" id={`accordioninnertitle${index}`} data-toggle="collapse" data-target={`#innertitle${index}`} aria-expanded="true">
                                            <i className="lnr lnr-pencil"></i>
                                        </a>
                                        <a className="dc-deleteinfo" onClick={() => deleteDownload(download.id)}>
                                            <i className="lnr lnr-trash"></i>
                                        </a>
                                    </div>
                                </div>
                                <div className="dc-collapseexp collapse show" id={`innertitle${index}`} aria-labelledby={`accordioninnertitle${index}`} data-parent="#accordion">
                                    <div className="dc-formtheme dc-userform">
                                        <fieldset>
                                            <div className="form-group form-group-half">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Download title"
                                                    value={download.title || ''}
                                                    onChange={(e) => handleDownloadChange(index, 'title', e.target.value)}
                                                />
                                            </div>
                                            {!download.file_id ? (
                                                <div className="form-group form-group-half">
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        onChange={(e) => handleFileUpload(index, e.target.files[0])}
                                                        disabled={isUploading}
                                                    />
                                                </div>
                                            ) : (

                                                <FileDownload fileid={download.file_id} filename={download.file} />

                                            )}
                                            <div className="form-group">
                                                <textarea
                                                    className="form-control"
                                                    placeholder="Download Description"
                                                    value={download.description || ''}
                                                    onChange={(e) => handleDownloadChange(index, 'description', e.target.value)}
                                                ></textarea>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Downloads;
